import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { SalesforceArchitecture } from './components/SalesforceArchitecture';
import { WhyDeploid } from './components/WhyDeploid';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { AnimatedBackground } from './components/AnimatedBackground';
export function App() {
  return <div className="min-h-screen bg-deep-navy text-white overflow-hidden relative" data-id="element-0">
      <AnimatedBackground data-id="element-1" />

      <div className="relative z-10" data-id="element-2">
        <Header data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <About data-id="element-6" />
          <Services data-id="element-7" />
          <SalesforceArchitecture data-id="element-8" />
          <WhyDeploid data-id="element-9" />
          <Contact data-id="element-10" />
        </main>
        <Footer data-id="element-11" />
      </div>
    </div>;
}